import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    header: {},
    title: {
      fontFamily: 'Roboto',
      fontSize: 8,
      fontWeight: 500,
      lineHeight: 2,
      letterSpacing: 2,
      color: 'rgba(0, 0, 0, .5)',
      textTransform: 'uppercase',
      marginBottom: 22,
    },
    content: {},
    toggler: {
      display: 'flex',
      alignItems: 'center',
    },
    full: {
      marginLeft: 12,
    },
    reverse: {
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
    },
  }
})
